// Ошибки полей формы (REC-007, поле fields): что сделать и пример (FR-030, ux.md, раздел 13).
// В contracts/errors.md текстов полей нет: здесь — общий набор для сервера и интерфейса.
// Метку {домен} заполняет сервер корпоративным доменом (fieldErrorsFromIssues).
export const fieldMessages = {
  fullName: 'Введите ФИО от 2 до 200 знаков, например Морозов Олег Сергеевич',
  email: 'Введите почту полностью, например morozov@{домен}',
  loginEmail: 'Введите почту',
  // 025: страница «Восстановление пароля» открыта без сеанса — доменов для примера нет.
  recoveryEmail: 'Введите почту полностью: имя, «@» и домен',
  password: 'Введите пароль',
  currentPassword: 'Введите текущий пароль',
  newPassword: 'Введите новый пароль',
  role: 'Выберите роль',
  areas: 'Выберите хотя бы одну область, например «Вся установка»',
  areasInstallationOnly:
    'У администратора клиента и сопровождения область — только «Вся установка»',
  area: 'Выберите область из списка',
  user: 'Выберите пользователя',
  assignment: 'Выберите роль, которую передаёте',
  deputy: 'Выберите заместителя',
  date: 'Введите дату, например 20.10.2026',
  dateOrder: 'Введите дату не раньше «С», например с 20.10.2026 по 31.10.2026',
  hours: 'Введите число часов от 1 до 24, например 2',
  reason: 'Напишите причину от 5 до 500 знаков, например «Разбор ошибки»',
  period: 'Конец периода — не раньше начала',
  operation: 'Введите номер операции из 12 знаков, например 7F3K-92QD-1A2B',
  errorCode: 'Введите код ошибки, например SYS-001',
  // 005: справочник, ключи агента.
  organizationName: 'Введите название от 2 до 300 знаков, например «Водоканал»',
  position: 'Должность — до 200 знаков, например «Главный инженер проекта»',
  aliasText: 'Введите написание от 1 до 200 знаков, например «ГИП»',
  unitName: 'Введите название от 2 до 200 знаков, например «Стройконтроль»',
  record: 'Выберите запись справочника',
  agentKeyName: 'Назовите ключ от 2 до 100 знаков, например «Список от отдела кадров»',
  agentKeyExpires: 'Срок ключа — не больше 90 дней от сегодня, например до 14.01.2027',
  // 008: подключение почты.
  senderName:
    'Имя отправителя — от 1 до 80 знаков без <, > и кавычек, например «Контроль протоколов»',
  senderAddress: 'Введите адрес на домене из Resend, например kontrol@send.example.ru',
  replyTo: 'Введите адрес полностью или оставьте пустым, например kontrol@example.ru',
  mailSignature: 'Подпись — до 200 знаков без ФИО, например «Отдел контроля поручений»',
  mailContact: 'Контакт — до 200 знаков без ФИО, например «kontrol@example.ru, доб. 120»',
  // 030: вход по коду, «Помощь», ответы «Моих задач», «Ошибка в пункте…».
  loginCode: 'Введите 6 цифр кода из письма',
  helpText: 'Напишите вопрос до 2000 знаков',
  dueReason: 'Напишите причину до 500 знаков, например «Поставка окон 10.11»',
  answerNote: 'Пояснение — до 2000 знаков',
  reportText: 'Кто отвечает — до 200 знаков, например «Рябов Р. Р.»',
} as const;

export type FieldMessage = (typeof fieldMessages)[keyof typeof fieldMessages];
